import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

/** One published bundle per native major version. */
export interface MajorVersionModel {
  major: number;
  version: string;
  hash: string;
  updateRequired?: boolean;
  data?: { [lang: string]: string };
}

export interface SaveAppVersionRequest {
  appName: string;
  major: number;
  version: string;
  hash: string;
  updateRequired?: boolean;
  data?: { [lang: string]: string };
}

/**
 * Live-update administration. Written against HttpClient directly: the vn client is
 * generated read-only, so the publish/upload calls are not in it.
 */
@Injectable({ providedIn: 'root' })
export class AppVersionService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = '/api/vn/app-versions';

  /** Bundle uploads go straight to the endpoint — nz-upload posts the multipart form itself. */
  readonly uploadUrl = `${this.baseUrl}/upload`;

  getVersions(appName: string): Promise<MajorVersionModel[]> {
    return firstValueFrom(this.http.get<MajorVersionModel[]>(this.baseUrl, { params: { app_name: appName } }));
  }

  saveVersion(req: SaveAppVersionRequest): Promise<void> {
    return firstValueFrom(this.http.post<void>(this.baseUrl, req));
  }

  removeVersion(appName: string, major: number): Promise<void> {
    return firstValueFrom(this.http.delete<void>(this.baseUrl, { params: { app_name: appName, major } }));
  }
}
